import Axios from "axios";
import {
  SET_BONUS_COMPARATIVE_REPORT_LIST,
  UNSET_BONUS_COMPARATIVE_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getBonusComparativeReport,
} from "@/store/api";

const state = {
  getBonusComparativeReport: [],
};

const getters = {
  getBonusComparativeReport(state) {
    return state.getBonusComparativeReport;
  },
};

const mutations = {
  [SET_BONUS_COMPARATIVE_REPORT_LIST](state, data) {
    state.getBonusComparativeReport = data;
  },
  [UNSET_BONUS_COMPARATIVE_REPORT_LIST](state) {
    state.getBonusComparativeReport = [];
  },
};

const actions = {
  getBonusComparativeReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getBonusComparativeReport}`, { params: data })
        .then((response) => {
          commit(SET_BONUS_COMPARATIVE_REPORT_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_BONUS_COMPARATIVE_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

